export enum AutomationVersionStrategy {
  Latest = "latest",
  Pinned = "pinned",
}
